import React, { useState } from "react";
import { Badge } from "react-bootstrap";
import { CommonButton, CommonInput } from "../Input";
import DataTable from "../table/DataTable";
import TopUpWithdrawDetailsModal from "./TopUpWithdrawDetailsModal";
import WithdrawalModal from "../Customers/WithdrawalModal";
import TopUpModal from "../Customers/TopUpModal";

const TopUpWithdrawList = () => {
  const [showDetailsModal, setShowDetailsModal] = useState(false);
  const [showWithdrawalModal, setShowWithdrawalModal] = useState(false);
  const [showTopUpModal, setShowTopUpModal] = useState(false);
  const [selectedTransaction, setSelectedTransaction] = useState(null);

  const [filters, setFilters] = useState({
    transactionId: "",
    customerName: "",
    email: "",
    startDate: "",
    endDate: "",
  });

  const columns = [
    { label: "Transaction ID", key: "id", className: "ps-4 text-start", style: { width: "120px" } },
    {
      label: "Date Time",
      key: "createdDate",
      render: (item) => (
        <div className="fs-12">
          <div className="fw-medium text-black">{item.displayDate}</div>
          <div className="text-muted">{item.time}</div>
        </div>
      ),
    },
    {
      label: "Type",
      key: "type",
      className: "text-center",
      render: (item) => (
        <Badge
          bg={item.type === "Top-up" ? "primary" : "light"}
          className={`px-3 py-1 rounded fw-bold border ${item.type === "Withdraw" ? "text-muted" : "text-white"}`}
          style={{ 
            fontSize: "11px",
            backgroundColor: item.type === "Top-up" ? "var(--primary)" : "#F2F4F7",
            borderColor: item.type === "Top-up" ? "var(--primary)" : "#EAECF0"
          }}
        >
          {item.type}
        </Badge>
      ),
    },
    {
      label: "Customer",
      key: "customer",
      render: (item) => (
        <div className="fs-12">
          <div className="fw-bold text-black">{item.customerName}</div>
          <div className="text-muted">{item.customerEmail}</div>
        </div>
      ),
    },
    {
      label: "Amount",
      key: "amount",
      render: (item) => (
        <span className="fw-bold text-black fs-13">{item.amount}</span>
      ),
    },
    {
      label: "Fee",
      key: "fee",
      render: (item) => (
        <span className="text-muted fs-13">{item.fee}</span>
      ),
    },
    {
      label: "Actions",
      key: "actions",
      className: "pe-4 text-center",
      render: (item) => (
        <button 
          className="btn btn-xs p-0 border-0 bg-transparent text-muted"
          onClick={() => {
            setSelectedTransaction(item);
            setShowDetailsModal(true);
          }}
        >
          <i className="far fa-eye fs-14"></i>
        </button>
      ),
    },
  ];

  const initialData = [
    {
      id: "261",
      date: "2026-03-10",
      displayDate: "10/03/2026",
      time: "10:43:53",
      type: "Withdraw",
      customerName: "Quang Nguyen",
      customerEmail: "checkpast12month@yopmail.com",
      amount: "100 SGD",
      fee: "6.55 SGD",
    },
    {
      id: "260",
      date: "2026-03-10",
      displayDate: "10/03/2026",
      time: "10:29:55",
      type: "Top-up",
      customerName: "SparkMinds Technology Pte Ltd",
      customerEmail: "checkpast12month@yopmail.com",
      amount: "2 SGD",
      fee: "--",
    },
    {
      id: "259",
      date: "2026-03-10",
      displayDate: "10/03/2026",
      time: "10:27:44",
      type: "Top-up",
      customerName: "SparkMinds Technology Pte Ltd",
      customerEmail: "checkpast12month@yopmail.com",
      amount: "400 SGD",
      fee: "--",
    },
    {
      id: "258",
      date: "2026-03-10",
      displayDate: "10/03/2026",
      time: "10:27:16",
      type: "Top-up",
      customerName: "SparkMinds Technology Pte Ltd",
      customerEmail: "checkpast12month@yopmail.com",
      amount: "1,000 SGD",
      fee: "--",
    },
    {
      id: "257",
      date: "2026-03-09",
      displayDate: "09/03/2026",
      time: "11:50:19",
      type: "Top-up",
      customerName: "SparkMinds Technology Pte Ltd",
      customerEmail: "checkpast12month@yopmail.com",
      amount: "110,117 SGD",
      fee: "--",
    },
  ];

  const [displayData, setDisplayData] = useState(initialData);

  const handleSearch = () => {
    let filtered = initialData.filter((item) => {
      const matchId = !filters.transactionId || 
        item.id.toLowerCase().includes(filters.transactionId.toLowerCase());
      const matchName = !filters.customerName || 
        item.customerName.toLowerCase().includes(filters.customerName.toLowerCase());
      const matchEmail = !filters.email || 
        item.customerEmail.toLowerCase().includes(filters.email.toLowerCase());
      const matchStart = !filters.startDate || item.date >= filters.startDate;
      const matchEnd = !filters.endDate || item.date <= filters.endDate;

      return matchId && matchName && matchEmail && matchStart && matchEnd;
    });
    setDisplayData(filtered);
  };

  const handleReset = () => {
    setFilters({
      transactionId: "",
      customerName: "",
      email: "",
      startDate: "",
      endDate: "",
    });
    setDisplayData(initialData);
  };

  return (
    <div className="container-fluid">
      <div className="d-flex flex-wrap align-items-center justify-content-between mb-4 gap-2">
        <h2 className="fw-bold text-black mb-0 fs-24">Top-up - Withdraw</h2>
        <div className="d-flex flex-wrap align-items-center gap-2">
          <CommonButton 
            variant="outline" 
            className="px-4"
            onClick={() => setShowWithdrawalModal(true)}
          >
            Withdrawal
          </CommonButton>
          <CommonButton 
            className="px-5 ms-2"
            onClick={() => setShowTopUpModal(true)}
          >
            Top-Up
          </CommonButton>
        </div>
      </div>

      <div className="d-flex flex-wrap align-items-center gap-2 mb-4">
        <div style={{ width: "160px" }}>
          <CommonInput
            placeholder="Enter transaction ID"
            value={filters.transactionId}
            onChange={(e) => setFilters({ ...filters, transactionId: e.target.value })}
          />
        </div>
        <div style={{ width: "160px" }}>
          <CommonInput
            placeholder="Enter customer name"
            value={filters.customerName}
            onChange={(e) => setFilters({ ...filters, customerName: e.target.value })}
          />
        </div>
        <div style={{ width: "160px" }}>
          <CommonInput
            placeholder="Enter email"
            value={filters.email}
            onChange={(e) => setFilters({ ...filters, email: e.target.value })}
          />
        </div>
        <div style={{ width: "140px" }}>
          <CommonInput
            type="date"
            placeholder="mm / dd / yyyy"
            value={filters.startDate}
            onChange={(e) => setFilters({ ...filters, startDate: e.target.value })}
          />
        </div>
        <div style={{ width: "140px" }}>
          <CommonInput
            type="date"
            placeholder="mm / dd / yyyy"
            value={filters.endDate}
            onChange={(e) => setFilters({ ...filters, endDate: e.target.value })}
          />
        </div>
        <CommonButton onClick={handleReset} variant="outline">
          <i className="flaticon-381-repeat-1"></i>
        </CommonButton>
        <CommonButton onClick={handleSearch}>
          <i className="fa fa-search text-white"></i>
        </CommonButton>
      </div>

      <div className="card border-0 shadow-sm rounded-4 overflow-hidden">
        <div className="card-body">
          <DataTable
            columns={columns}
            data={displayData}
            showPagination={false}
            minWidth="100%"
          />
        </div>
      </div>

      <TopUpWithdrawDetailsModal
        show={showDetailsModal}
        onHide={() => setShowDetailsModal(false)}
        transaction={selectedTransaction}
      />

      <WithdrawalModal
        show={showWithdrawalModal}
        onHide={() => setShowWithdrawalModal(false)}
      />

      <TopUpModal
        show={showTopUpModal}
        onHide={() => setShowTopUpModal(false)}
      />
    </div>
  );
};

export default TopUpWithdrawList;
